module.exports = __webpack_public_path__ + "img/032a2de5ddadcd49c4a6d25dfb1fba2c.faac9055.jpg";